import { useQuery } from "@apollo/client";
import { Sangha } from "@app/shared/types";
import { Box, BoxProps } from "@mui/material";
import { GRAPHQL_QUERY_AVAILABLE_GROUPS } from "app/queries";
import { routes } from "app/routes";
import LoadingPage from "features/pages/LoadingPage";
import NotFoundPage from "features/pages/NotFoundPage";
import { useHistory } from "react-router";
import ImmersionGroupCard from "../community/ImmersionGroupCard";

export interface MentorshipGroupPromoSectionProps extends BoxProps {
    elementBefore?: React.ReactNode;
    elementAfter?: React.ReactNode;
}

export const MentorshipGroupPromoSection = (props: MentorshipGroupPromoSectionProps) => {
    const { elementBefore, elementAfter, ...others } = props;

    const history = useHistory();

    const { data, loading, error } = useQuery(GRAPHQL_QUERY_AVAILABLE_GROUPS, {
        variables: { limit: 2 },
    });

    const groups = data ? (Object.values(data)[0] as Sangha[]) : undefined;

    const handleOnClaimSpot = (group: Sangha) => {
        history.push(`${routes.memberSanghas()}?preferredGroupId=${group.id}`);
    };

    if (error) {
        return <NotFoundPage />;
    }

    if (loading) {
        return <LoadingPage />;
    }

    if (!groups || groups.length < 1) {
        return null;
    }

    return (
        <Box {...others}>
            <>
                {elementBefore}
                {groups.map((group) => (
                    <ImmersionGroupCard
                        key={group.id}
                        sangha={group}
                        handleOnClaimSpot={() => handleOnClaimSpot(group)}
                        claimButtonText={"Claim your spot"}
                    />
                ))}
                {elementAfter}
            </>
        </Box>
    );
};
